<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Correction",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Correction",
      items: [
        {
          text: "Home",
        },
         {
          text: "Tracking",
        },
        {
          text: "Correction",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>